/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A6Inputs */

const en_to_typescript_faq_a6 = /** @type {(inputs: To_Typescript_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Each nested object gets an interface named after its key, so two structurally identical objects under different keys produce two interfaces. Merge them by hand if you want a single shared type.`)
};

const ko_to_typescript_faq_a6 = /** @type {(inputs: To_Typescript_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하지 않습니다. 중첩 객체마다 그 키 이름을 딴 인터페이스가 생기므로, 서로 다른 키 아래 구조가 같은 두 객체는 두 개의 인터페이스를 만듭니다. 공유 타입 하나로 만들려면 직접 병합하세요.`)
};

const ja_to_typescript_faq_a6 = /** @type {(inputs: To_Typescript_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`されません。ネストしたオブジェクトごとにそのキー名を取ったインターフェースができるので、異なるキーの下の構造的に同一な 2 つのオブジェクトは 2 つのインターフェースを生みます。共有型 1 つにしたいなら手で統合してください。`)
};

/**
* | output |
* | --- |
* | "No. Each nested object gets an interface named after its key, so two structurally identical objects under different keys produce two interfaces. Merge them b..." |
*
* @param {To_Typescript_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a6 = /** @type {((inputs?: To_Typescript_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a6(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a6(inputs)
	return ja_to_typescript_faq_a6(inputs)
});